import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Scroll from "../Header/Scroll";
import Banner from "./components/Banner";
import About from "./components/About";
import Categories from "./components/Categories";
import Judges from "./components/Judges";
import Gallery from "./components/Gallery";
import Blog from "./components/Blog";
import Sponsor from "./components/Sponsor";
import Image2 from "../../assets/banner/2026_banner_4.png";

const styles = {
  paperContainer: {
    height: 1000,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Home = () => {
  return (
    <Box>
      <Helmet>
        <title> Homepage | BudgIT Active Citizens Awards</title>
      </Helmet>
      <Scroll>
        <AppBar position={"sticky"} elevation={0}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Banner />
      </Box>
      <Box
        style={styles.paperContainer}
        display={{ xs: "block", sm: "none" }}
        marginTop={"8%"}
      ></Box>
      <Box>
        <Container>
          <About />
        </Container>
      </Box>
      <Box bgcolor={"#831312"}>
        <Container>
          <Categories />
        </Container>
      </Box>
      <Box>
        <Container>
          <Judges />
        </Container>
      </Box>
      <Box bgcolor={"#049593"}>
        <Container>
          <Gallery />
        </Container>
      </Box>
      <Box>
        <Container>
          <Blog />
        </Container>
      </Box>
      <Box>
        <Container>
          <Sponsor />
        </Container>
      </Box>
      <Box bgcolor={"#049593"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
